<template>
  <RevInfoBlock
    :icon="IconWarning"
    :title="i18n(translations.title)"
    variant="warning"
  >
    <div class="body-2">
      {{ i18n(translations.content) }}
      <RevLink
        class="body-2-link"
        data-qa="faq-link"
        target="_blank"
        :to="warrantyFaqArticleLink"
      >
        {{ i18n(translations.link) }}
      </RevLink>
    </div>
  </RevInfoBlock>
</template>

<script lang="ts" setup>
import { useZendeskFaqBaseUrl } from '@backmarket/nuxt-layer-base/composables/useZendeskFaqBaseUrl'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconWarning } from '@ds/icons/IconWarning'

import { WARRANTY_FAQ_ARTICLE } from '@/scopes/customer-care/resolution/components/ResolutionFlowScreens/ResolutionFlowScreens.constants'

import translations from './WarrantyExclusionInfo.translations'

const i18n = useI18n()
const { zendeskFaqBaseUrl } = useZendeskFaqBaseUrl()

const warrantyFaqArticleLink = toNuxtLink({
  type: 'external',
  href: `${zendeskFaqBaseUrl}/articles/${WARRANTY_FAQ_ARTICLE.id}`,
})
</script>
